import { RiskConsequenceCategory } from "./RiskConsequences.types";

export function getRiskConsequenceCategoryOptions(translateCategory: (category: RiskConsequenceCategory) => string) {
    return Object.values(RiskConsequenceCategory)
        .filter((value): value is RiskConsequenceCategory => typeof value === "number")
        .map((category) => ({ id: category.toString(), name: translateCategory(category) }));
}
